
export default {
    S:100,
    M:120,
    L:180,
    XL:240
}


// WEBPACK FOOTER //
// ./src/pages/haierProduct/common/columnWidth.js